import ProductCombinationCard from "@components/Cards/ProductCombinationCard"
import { ProductCombinationGrid } from "@components/Cards/ProductCombinationCard/elements"
import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"
import { Paragraph, TitleLAlt } from "@components/Typography"
import { productGroupToUid } from "@config/general"
import imgix from "@config/imgix"
import { ChoicesArticleCombination } from "@generated"
import { FC, Fragment } from "react"

type GridProps = {
  loading: boolean
  fetchingMore: boolean
  items: ChoicesArticleCombination[]
  firstTitle: any | null
  firstText: any | null
  secondTitle: any | null
  secondText: any | null
}

const loadingItems = Array.from(Array(6)).map((u, i) => (
  <ProductCombinationCard key={`loading-${i}`} isLoading href="" />
))

export const Grid: FC<GridProps> = ({
  loading,
  fetchingMore,
  items,
  firstTitle,
  firstText,
  secondTitle,
  secondText,
}) => {
  const { messages } = useIntl()
  return (
    <ProductCombinationGrid data-testid="ac-grid">
      {loading && !fetchingMore
        ? loadingItems
        : items.map((item, index) => {
            const uid = productGroupToUid[item.product_group]
            let as = `${messages.navigation[uid].url}/${item.slug}-${item.id}`
            const card = (
              <ProductCombinationCard
                key={item.id}
                price={item.price}
                title={item.name}
                as={as}
                href={`${messages.navigation.collectionProductDetail.url}`}
                productImage={
                  item.images
                    ? imgix({
                        key: item.images[0].path.replace(".png", ""),
                        type: "articleCombination",
                        args: {
                          w: 500,
                          h: 500,
                        },
                      })
                    : undefined
                }
              />
            )
            return index === 5 ? (
              <Fragment key={`frag-${index}`}>
                <Box
                  key="first-content"
                  p={[0, 4]}
                  py={[4, 0]}
                  display="flex"
                  alignItems="center"
                  textAlign={["center", "left"]}
                >
                  <Box>
                    <TitleLAlt as="h2">{firstTitle}</TitleLAlt>
                    <Paragraph>{firstText}</Paragraph>
                  </Box>
                </Box>
                {card}
              </Fragment>
            ) : index === 8 ? (
              <Fragment key={`frag-${index}`}>
                <Box
                  key="second-content"
                  p={4}
                  display="flex"
                  alignItems="center"
                >
                  <Box>
                    <TitleLAlt as="h2">{secondTitle}</TitleLAlt>
                    <Paragraph>{secondText}</Paragraph>
                  </Box>
                </Box>
                {card}
              </Fragment>
            ) : (
              card
            )
          })}
      {fetchingMore && loadingItems}
    </ProductCombinationGrid>
  )
}
